import React, { Fragment } from "react";
import { isEqual } from "lodash";

//components
import Input from "./Input";

/*

all inputs, their defaults and validator functions are
passed in through this.props.inputs.
 */

export default class BaseForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.randomId = "_" + Math.floor(Math.random() * 1000000000);
  }

  //only property names and their corresponding variables can live in state
  setStateFromInputProp = () => {
    let newState = {};
    this.props.inputs.forEach((d) => {
      newState[d.dataKey] = this.state[d.dataKey] || d.value || "";
      newState[d.dataKey + "_error"] =
        this.state[d.dataKey + "_error"] || false;
    }, {});
    this.setState(newState);
  };

  resetFormValues = () => {
    const newState = this.props.inputs.reduce((r, d) => {
      r[d.dataKey] = d.defaultValue || "";
      r[d.dataKey + "_error"] = false;
      return r;
    }, {});

    let form = document.getElementById(this.randomId);
    if (form) {
      // form.reset()
      this.setState(newState);
    }
  };

  componentDidMount() {
    this.setStateFromInputProp();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.inputs, this.props.inputs)) {
      this.setStateFromInputProp();
    }

    if (!isEqual(prevProps.reset, this.props.reset)) {
      this.resetFormValues();
    }
  }

  validateInput = (inputObject, val) => {
    if (inputObject.validator) {
      try {
        if (!inputObject.validator(val)) {
          this.setState({ [inputObject.dataKey + "_error"]: true });
        } else {
          this.setState({ [inputObject.dataKey + "_error"]: false });
        }
      } catch (e) {
        console.error("validation error", e);
      }
    }
  };

  handleValueChange = (inputObject, val) => {
    this.validateInput(inputObject, val);
    this.setState({ [inputObject.dataKey]: val });
    this.props.onValueChange &&
      this.props.onValueChange(inputObject.dataKey, val);
  };

  returnStateForSubmission = () => {
    return Object.keys(this.state)
      .filter((d) => !d.includes("_error"))
      .reduce((r, d) => {
        r[d] = this.state[d];
        return r;
      }, {});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const checkAndSubmit = () => {
      //if there aren't any errors, pass to submit function.
      // if there are errors, and we've passed a function to handle that, call onSubmissionFailure prop
      if (
        Object.keys(this.state)
          .filter((d) => d.includes("_error"))
          .map((d) => this.state[d])
          .every((d) => !d)
      ) {
        const submissionData = this.returnStateForSubmission();
        const result = this.props.onSubmit(submissionData);
        if (result != null && typeof result.then === "function") {
          result
            .then(() => this.resetFormValues())
            .catch(() => {});
        } else {
          this.resetFormValues();
        }
      } else {
        console.log("submission failure");
        if (this.props.onSubmissionFailure) {
          this.props.onSubmissionFailure();
        }
      }
    };

    //validate the input for those inputs that have a validator function
    //pass actual submission afterwards to avoid race condition
    (this.props.inputs || []).forEach((d, i, a) => {
      this.validateInput(d, this.state[d.dataKey]);
      if (i === a.length - 1) {
        setTimeout(checkAndSubmit, 10);
      }
    });
  };

  renderInputs() {
    if (!this.props.inputs) return [];

    return this.props.inputs.map((d) => (
      <Fragment key={d.dataKey}>
        <Input
          {...d}
          value={this.state[d.dataKey] ?? d.value ?? ""}
          onChange={(val) => this.handleValueChange(d, val)}
        />
        {!!this.state[d.dataKey + "_error"] && (
          <div className={"input-error danger-text"}>
            {d.errorMsg || "This field is not valid."}
          </div>
        )}
      </Fragment>
    ));
  }

  hasError = () => {
    return this.props.inputs.some((d) => this.state[d.dataKey + "_error"]);
  };

  render() {
    return (
      <>
        <form
          className={"baseForm " + this.props.className}
          onSubmit={this.handleSubmit}
          action={"#"}
          id={this.randomId}
        >
          {this.props.title && (
            <h4 className={"primary-text"}>{this.props.title}</h4>
          )}
          <fieldset>
            {this.renderInputs()}
            {this.props.children}
          </fieldset>
          <div className="button-wrapper">
            <button
              onClick={this.handleSubmit}
              className={`button ${
                this.props.disableSubmit || this.hasError() ? "disabled" : ""
              }`}
            >
              {this.props.submitButtonText || "Submit"}
            </button>
            {!!this.props.onCancel && (
              <button
                className="button button-outline"
                onClick={(ev) => {
                  ev.preventDefault();
                  this.props.onCancel();
                }}
              >
                Cancel
              </button>
            )}
            {this.props.otherButtons}
          </div>
        </form>
      </>
    );
  }
}
